import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 11.5l4.5 4.5h9l-9 -9l-4.5 4.5","key":"svg-0"}],["path",{"d":"M16.5 16l4.5 -4.5l-4.5 -4.5l-4.5 4.5","key":"svg-1"}]]

/**
 * IconBrandAlpineJs
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtYWxwaW5lLWpzIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0zIDExLjVsNC41IDQuNWg5bC05IC05bC00LjUgNC41IiAvPgogIDxwYXRoIGQ9Ik0xNi41IDE2bDQuNSAtNC41bC00LjUgLTQuNWwtNC41IDQuNSIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/brand-alpine-js
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandAlpineJs = createReactComponent('outline', 'brand-alpine-js', 'BrandAlpineJs', __iconNode);

export default IconBrandAlpineJs;